<template>
	<!-- {{ model }} -->
	<div class="form input-file berufsnachweis profilbearbeiten" v-if="!isDone">
		<p>Berufsnachweis hochladen (PDF, Bildformate, max. {{maxUploadSizeMb}} MB)</p>
		<div class="file-upload" >
			<div class="upload-step-1" v-if="showStepOne" :class="{'active':showStepOne}">
				<button class="btn-file-select" type="button" @click.prevent="triggerUpload">Schritt 1: Datei auswählen</button>
			</div>

			<div class="upload-wrap">
				<div class="upload-dragarea" @drop.prevent="handleDrop" @dragover.prevent=""  v-if="showStepOne">
					<input class="file-upload-input" type="file" accept="application/pdf,image/*" id="BerufsnachweisFile" @change.prevent="fileUploadChange">
						<div class="drag-text">
							<h3>{{ uploadText }}</h3>
						</div>
					</input>
				</div>
				<div class="file-upload-content"   v-if="!showStepOne">
					<span class="image-title">{{ uploadText }}</span>
					<div class="image-title-wrap">
						<button class="btn-upload-remove" type="button" @click.prevent="removeUpload"><img :src="'/images/icon_delete.png'" /></button>
					</div>
				</div>
			</div>

			<div class="upload-step-2" v-if="!showStepOne" :class="{'active':!showStepOne}">
				<button class="btn-file-upload" type="button" @click.prevent="uploadBerufsnachweis">Schritt 2: Datei Hochladen</button>
			</div>			
		</div>
	</div>
	<div id="upload-status" :class="{'success':isDone}">{{ statusText }}</div>
	<div v-if="model?.letzterUpload" style="padding:5px;background-color:#efefef;margin-bottom:5px;">
		<label id="LetzteDatei">Letzte hochgeladene Datei zum Berufsnachweis: <strong>{{model.letzterUpload}}</strong></label>
	</div>
</template>

<script lang="ts">
import ApiService from '@/services/apiService';
import { defineComponent, useTemplateRef } from 'vue';

var UploadBerufsnachweis = defineComponent({
	props:{
		model: Object,
		sessionId: String,
		uploadGuid: String,
	},
	data(){
		return {
			maxUploadSizeMb: 0,
			statusText: "",
			uploadText: "Eine Datei auf dieses Feld ziehen oder Klicken",
			showStepOne: true,
			isDone: false,
			file:{} as File | null,
		}
	},
	methods: {
		handleDrop(event: DragEvent){
			if(event.dataTransfer?.items){
				[...event.dataTransfer.items].forEach((item:DataTransferItem) => {
					if(item.kind === "file"){
						this.file = item.getAsFile();
						if(this.file){
							this.readFile();
						}
					}
				});
			}
		},
		fileUploadChange(event:Event){
			const input = event.target as HTMLInputElement;
			if (!input.files?.length) {
				return;
			}
			this.file = input.files[0];
			this.readFile();
		},
		async uploadBerufsnachweis(){
			if(!this.file){
				this.statusText = "Bitte wählen Sie eine Datei aus.";
			}
			else{
				this.statusText = "Bitte warten...";
				const formData = new FormData();
				formData.append('file',this.file);
				formData.append('userguid', this.model?.guid? this.model?.guid : this.model?.newUserGuid);
				formData.append('sessionId', this.model?.sessionId);
				const response = await ApiService.Instance.PostData("/umbraco/api/Berufsnachweis/Upload", formData, false) as {status:string, data:object};
				if(response.status == "200"){
					this.statusText="Der Upload war erfolgreich";
					this.model.berufsnachweis = response.data;
					// this.uploadText = this.file.name;
					this.done();
				}else{
					if(response.status == "404" || response.status == "413"){
						this.statusText = "Ein Fehler ist aufgetreten. Die Dateigröße ist möglicherweise größer als 10 MB.";
					}
					else {
						if(parseInt(response.status) >=500){
							this.statusText = "Ein Server-Fehler ist aufgetreten.";
						}else {
							this.statusText = "Ein Fehler mit dem Code " + response.status + " ist aufgetreten."
						}
					}
				}
			}
		},
		readFile(){
			if(this.file){
				this.showStepOne = false; //showStep2
				this.uploadText = this.file?.name ?? "";
			}else{
				this.removeUpload();
			}
		},
		removeUpload(){
			if(this.model){
				this.model.berufsnachweis= null;
			}
			this.showStepOne = true; //showStep1
			this.uploadText = "Eine Datei auf dieses Feld ziehen oder Klicken";
			this.statusText = "";
		},
		done(){
			this.isDone = true;
		},
		triggerUpload(){
			const uploadInput = document.getElementById("BerufsnachweisFile")
			if(uploadInput){
				uploadInput.click();
			}
		}
	},
});

export default UploadBerufsnachweis;
</script>